import { render, staticRenderFns } from "./depositExamineExtra.vue?vue&type=template&id=0287866d"
import script from "./depositExamineExtra.vue?vue&type=script&lang=js"
export * from "./depositExamineExtra.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports